// Auto-generated language file from /opt/wh/whtree/modules/tollium/web/ui/components/basecontrols/calendar2.lang.json
var registerTexts = require("@webhare-tollium/gettid").registerTexts;
registerTexts("tollium","en",{"common":{"actions":{"cancel":"Cancel","today":"Today"},"labels":{"none":"None"}}});
registerTexts("tollium","nl",{"common":{"actions":{"cancel":"Annuleren","today":"Vandaag"},"labels":{"none":"Geen"}}});
// Adding dependency: /opt/webhare/modules/tollium/language/default.xml
// Adding dependency: /opt/webhare/modules/tollium/language/nl.xml



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/modules/tollium/web/ui/components/basecontrols/calendar2.lang.json
// module id = 1128
// module chunks = 0